import { FormControl } from '@angular/forms';

export function requiredPhone(
  control: FormControl
): { [s: string]: boolean } | null {
  const value = control.value as string;

  if (!value) {
    return { requiredPhone: true };
  }

  return null;
}
